import context from '@/context'

export const initialState = {

  changing: false,
  reportSubmittersLastReloadedAt: new Date()
}

export const actionTypes = {

  Changing: 'reportSubmitters/changing',
  Changed: 'reportSubmitters/changed'
}

export const actionCreators = {

  saveInstitutionReportSubmitter: (input) => (dispatch) => {
    dispatch({ type: actionTypes.Changing })
    context.api.reportGroupsService.saveInstitutionReportSubmitter(input)
      .then(() => dispatch({ type: actionTypes.Changed }))
      .catch(() => dispatch({ type: actionTypes.Changed }))
  },
  removeInstitutionReportSubmitter: (reportGroupId, id) => (dispatch) => {
    dispatch({ type: actionTypes.Changing })
    context.api.reportGroupsService.removeInstitutionReportSubmitter(reportGroupId, id)
      .then(() => dispatch({ type: actionTypes.Changed }))
      .catch(() => dispatch({ type: actionTypes.Changed }))
  },

  saveInstitutionGroupReportSubmitter: (input) => (dispatch) => {
    dispatch({ type: actionTypes.Changing })
    context.api.reportGroupsService.saveInstitutionGroupReportSubmitter(input)
      .then(() => dispatch({ type: actionTypes.Changed }))
      .catch(() => dispatch({ type: actionTypes.Changed }))
  },

  removeInstitutionGroupReportSubmitter: (reportGroupId, id) => (dispatch) => {
    dispatch({ type: actionTypes.Changing })
    context.api.reportGroupsService.removeInstitutionGroupReportSubmitter(reportGroupId, id)
      .then(() => dispatch({ type: actionTypes.Changed }))
      .catch(() => dispatch({ type: actionTypes.Changed }))
  },
  excludeInstitutionReportSubmitter: (input) => (dispatch) => {
    dispatch({ type: actionTypes.Changing })
    context.api.reportGroupsService.excludeInstitutionReportSubmitter(input)
      .then(() => dispatch({ type: actionTypes.Changed }))
      .catch(() => dispatch({ type: actionTypes.Changed }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.Changing: return { ...state, changing: true }
    case actionTypes.Changed: return { ...state, changing: false, reportSubmittersLastReloadedAt: new Date() }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/ReportSubmitters.js